import React from "react";
import { AgGridReact } from "ag-grid-react";
import { InfiniteRowModelModule } from "@ag-grid-community/infinite-row-model";
import { RotatingLines } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { getMeetingGridOptions } from "./meetingDetailsGridConfig";
import { PAGE_SIZE } from "./meetingDetailsConstants";

/**
 * Shared grid + footer for meeting lists (accordion body or sidebar main panel).
 * Uses AG Grid Infinite Row Model (server paging via datasource).
 */
export default function MeetingDetailsGridPanel({
  section,
  sectionIndex,
  isLoading,
  datasource,
  columnDefs,
  defaultColDef,
  cellClickedListener,
  onGridReady,
  rowClassRules,
  onSelectionChanged,
  onSortChanged,
  onFilterChanged,
  gridRef,
  gridHeight = 450,
}) {
  const { t } = useTranslation();
  const e = section;

  const baseGridOptions = getMeetingGridOptions(e.type);

  return (
    <>
      <div
        className="ag-theme-alpine"
        style={{
          width: "100%",
          height: gridHeight,
          position: "relative",
        }}
      >
        {isLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "absolute",
              inset: 0,
              zIndex: 2,
              background: "rgba(255,255,255,0.65)",
            }}
          >
            <RotatingLines
              strokeColor="grey"
              strokeWidth="5"
              animationDuration="0.75"
              width="48"
              visible={true}
            />
          </div>
        )}
        <AgGridReact
          ref={(el) => {
            gridRef.current[sectionIndex] = el;
          }}
          modules={[InfiniteRowModelModule]}
          rowModelType="infinite"
          datasource={datasource}
          cacheBlockSize={PAGE_SIZE}
          maxBlocksInCache={20}
          infiniteInitialRowCount={1}
          rowBuffer={0}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          rowSelection="multiple"
          onCellClicked={cellClickedListener}
          alwaysShowHorizontalScroll={true}
          alwaysShowVerticalScroll={true}
          onGridReady={(params) => onGridReady(params, e.type)}
          rowClassRules={rowClassRules}
          onSelectionChanged={(event) => onSelectionChanged(event, e.type)}
          onSortChanged={onSortChanged}
          onFilterChanged={(ev) => onFilterChanged?.(ev, e.type)}
          suppressRowClickSelection
          gridOptions={baseGridOptions}
        />
      </div>
      {(e.totalCount > 0 || e.totalPages > 1) && (
        <div className="mt-2 px-2">
          <span style={{ fontSize: "13px", color: "#666" }}>
            {t("Meeting list footer", {
              shown: e.meetings.length,
              total: e.totalCount,
              page: e.page,
              pages: e.totalPages,
            })}
          </span>
        </div>
      )}
    </>
  );
}
